<template>
  <line-chart
    :title="title"
    :series="chartSeries"
    :xAxis="xAxisOptions"
    :yAxis="yAxisOptions"
    :colors="['#4CAF50', '#2196F3']"
    :legend="true"
    :loading="loading"
    height="300"
  />
</template>

<script>
import LineChart from "@/components/common/charts/LineChart.vue";
import { formatNumber, formatBytes } from "@/utils/formatting";

export default {
  name: "TableStatsChart",
  components: {
    LineChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartSeries() {
      if (!this.data || this.data.length === 0) {
        return [];
      }

      return [
        {
          name: "Nombre de lignes",
          data: this.data.map((item) => item.num_rows),
        },
        {
          name: "Taille",
          data: this.data.map((item) => item.table_size_mb * 1024 * 1024), // Convert MB back to bytes for formatting
        },
      ];
    },
    xAxisOptions() {
      return {
        categories: this.data ? this.data.map((item) => item.date) : [],
        labels: {
          rotate: -45,
          rotateAlways: true,
          style: {
            fontSize: "12px",
            fontWeight: 400,
          },
        },
      };
    },
    yAxisOptions() {
      return [
        {
          seriesName: "Nombre de lignes",
          opposite: false,
          title: {
            text: "Nombre de lignes",
            style: {
              color: "#4CAF50",
              fontSize: "12px",
            },
          },
          labels: {
            style: {
              colors: "#4CAF50",
            },
            formatter: (value) => formatNumber(value, { compact: true }),
          },
        },
        {
          seriesName: "Taille",
          opposite: true,
          title: {
            text: "Taille",
            style: {
              color: "#2196F3",
              fontSize: "12px",
            },
          },
          labels: {
            style: {
              colors: "#2196F3",
            },
            formatter: (value) => formatBytes(value, 1),
          },
        },
      ];
    },
  },
};
</script>
